export const glgTexts = {
	knowMore: 'Saber máis',
	ngoPurpose:
		'La captación de fondos para proyectos de la ONG,mantenerle informado sobre la ONG y la evolución del proyecto para el que ha donado fondos y la emisión de certificados de desgravación fiscal.',
	termsPurpose:
		'Gestionar la relación negocial en todos sus ámbitos, así como su donación y su solicitud de certificado, y el envío de comunicaciones comerciales por vía electrónica.',
	termsRights:
		'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
	termsAdditionalInfo:
		'Puedes consultar información adicional y detallada sobre Protección de datos en nuestra página <a href="https://www.worldcoo.com/gdpr">web</a> o bien contactando en <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
	termsRecipients:
		'No se cederán datos a terceros, excepto a los encargados de tratamiento fuera de la UE, acogidos a Privacy Shield.',
	unexpectedError: 'Houbo un erro inesperado',
	amountError: 'A cantidade de diñeiro non era válida',
	authError: 'Houbo un erro ao autorizar o pago',
	cardError: 'Produciuse un erro coa túa tarxeta',
	referralError: 'Houbo a Reference Bug',
	transactionError: 'Houbo a transaction error',
	resetFilters: 'Borrar filtros',
	category: 'Causa',
	basicNeeds: 'Necesidades básicas',
	humanRights: 'Dereitos humanos',
	education: 'Educación',
	emergency: 'Emerxencia',
	feeding: 'Alimentación',
	environment: 'Medio ambiente',
	habitat: 'Habitat',
	health: 'Saúde',
	clear: 'Limpar',
	active: 'Activo',
	finished: 'Finalizado',
	status: 'Estado',
	filters: 'Filtros',
	year: 'Ano',
	dedicateToTemplate:
		'¡Hola! Recibes este correo porqué {{donorName}} te ha dedicado una donación de {{amount}}{{currency}} para la ONG {{ngoName}} en la campaña {{campaignName}}. Esta donación te la ha dedicado a ti con la intención de hacer del mundo un lugar un poco mejor',
	dedicateToTemplateTitle: 'A mensaxe da túa dedicación.',
	dedicateToWarning:
		'Esta mensaxe enviarase ao destinatario no enderezo de correo electrónico indicado anteriormente. Confirmo que solicitei permiso ao destinatario para enviar esta mensaxe',
	dedicateToRecipientEmail: 'Correo electrónico do destinatario.',
	dedicateToRecipientName: 'Nome do destinatario.',
	dedicateDonationTitle: 'Quero dedicar a miña doazón a alguén.',
	dedicateDonationMessage: 'Gustaríame dedicar a miña doazón a alguén',
	responsable: 'Responsable',
	purpose: 'Finalidade',
	legitimation: 'Lexitimación',
	recipients: 'Destinatarios',
	rights: 'Dereitos',
	ngoAdditionalInfoTitle: 'Localización de información adicional',
	termsButton: 'Lin, acepto e entendo',
	id: 'NIF / NIE',
	taxId: 'CIF',
	passport: 'Pasaporte',
	others: 'Outros',
	campaignAudited: 'Campaña auditada por',
	aCampaignBy: 'Unha campaña de:',
	termsAndCons: 'termos de Protección de datos de Worldcoo',
	ngoTerms: 'Condicións de protección de datos',
	haveReadAndAccept: 'Lin, comprendín e acepto',
	acceptNgoTermsLink: 'termos de Protección de Datos da {{ngo}}',
	acceptRecurrentTermsLink: 'termos de Protección de Datos das ONG',
	activities: 'Actividades',
	additionalInfo: 'Información adicional',
	anyComments: 'Queres deixar algún comentario?',
	businessName: 'Razón social',
	campaignObjectives: 'Obxectivos da campaña',
	campaignFunded: 'Campaña financiada!',
	campaigns: 'Campañas',
	cancel: 'Cancelar',
	cardBrandNotAccepted: 'Non se acepta este tipo de tarxetas.',
	cardRegisteredSuccessfully: 'Rexistrouse a tarxeta con éxito',
	cardsSupported: 'Tarxetas válidas:',
	certificateOnlyValidInExpeditionCountry:
		'O certificado de doazón só terá validez no país de orixe no que estea inscrita a entidade beneficiaria dos donativos.',
	certificateNeededData: 'Datos necesarios para obter o certificado de doazón:',
	change: 'Trocar',
	checkoutSuccess: 'A túa doazón realizouse correctamente, grazas por participar.',
	city: 'Cidade',
	collectedFundsDistribution: 'Os fondos recadados repartiranse equitativamente entre os proxectos seguintes:',
	comments: 'Comentarios',
	company: 'Empresa',
	confirm: 'Confirmar',
	contactData: 'Datos de contacto',
	cookiesMessage: 'Este sitio utiliza rastros. Se continuas a navegar consideramos que aceptas o seu uso.',
	country: 'País',
	creditCard: 'Tarxeta de crédito',
	dataReceivedSuccessfully: 'Recibimos correctamente os teus datos.',
	description: 'Descrición',
	directBeneficiaries: 'Beneficiarios directos',
	directBeneficiariesDescription:
		'As persoas que de forma natural resultaran beneficiadas polas accións realizadas na campaña',
	documentNumber: 'Núm. de documento',
	documentType: 'Tipo de documento',
	donationAmount: 'Importe da doazón',
	donationAmountError: 'O importe da doazón non é correcto',
	donationAmountMinimumIs: 'O importe mínimo é de {{amount}}',
	donationCertificate: 'Certificado de doazón',
	donations: 'Doazóns',
	donors: 'Doantes',
	donated: 'Doados',
	donatedOf: 'Doados de',
	donateMonthly: 'Doar mensualmente',
	donationOnBehalf: 'Doar en nome de',
	door: 'Porta',
	email: 'Correo electrónico',
	fillFollowingFields: 'Cubre os campos seguintes',
	finish: 'Finalizar',
	floor: 'Piso',
	funded: 'Financiado',
	genericCardError: 'Houbo algún problema coa túa tarxeta.',
	goBack: 'Volver',
	identityDocument: 'Documento de identidade',
	indicateDataToIdentify: 'Indícanos estes datos para que podamos identificarte:',
	indirectBeneficiaries: 'Beneficiarios indirectos',
	indirectBeneficiariesDescription:
		'As persoas identificables que reciben un efecto potencial das accións realizadas na campaña.',
	inDoubtContactHere: 'Se tes calquera dúbida, podes contactarnos aquí:',
	informYouViaMail: 'Informarémoste por correo electrónico con todo detalle.',
	makeDonation: 'Doar',
	makeOneTimeDonation: 'Doar de maneira puntual',
	makeYourDonation: 'Doa',
	manageMyDonations: 'Xestionar as miñas doazóns',
	manyThanks: 'Moitas grazas!',
	modifyAmount: 'Modificar o importe da doazón',
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">Recibimos correctamente a túa solicitude.</p><p>Nuns días enviarémoste un correo electrónico confirmando que realizamos os cambios solicitados.</p><p>Se tes calquera dúbida podes contactarnos aquí:</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Se xa es doante, aquí podes modificar ou cancelar a túa doazón:',
	moreInfo: 'Máis información',
	name: 'Nome',
	next: 'Seguinte',
	otherAmount: 'Outra cantidade',
	overlayError:
		'<p>Produciuse un erro.</p><p>Por favor, inténtao novamente máis tarde ou contacta connosco aquí:</p><p><strong>contact@worldcoo.com</strong></p>',
	particular: 'Particular',
	paymentData: 'Datos de pagamento',
	paymentType: 'Forma de pagamento',
	personalData: 'Datos persoais',
	pleaseFillFields: 'Por favor, cubre os datos seguintes:',
	postalCode: 'Código postal',
	province: 'Provincia',
	raised: 'Recadados',
	raisedTillNow: 'Recadado ata o momento:',
	recurrentFormError:
		'Houbo algún problema durante o procesamento da túa solicitude. Por favor, inténtao máis tarde ou contáctanos aquí:',
	region: 'Rexión',
	repeatEmail: 'Repetir correo electrónico',
	repsolEmployeesPortal: 'Portal solidario para empregados',
	seeCampaigns: 'Ver campañas',
	send: 'Enviar',
	share: 'Compartir',
	sorry: 'O sentimos!',
	stairNumber: 'Escaleira',
	stopMakingDonation: 'Deixar de doar de maneira mensual',
	step1: 'Paso 1',
	step2: 'Paso 2',
	step3: 'Paso 3',
	step4: 'Paso 4',
	streetName: 'Nome da vía',
	streetNumber: 'Núm.',
	streetType: 'Tipo de vía',
	summary: 'Resumo',
	surname: 'Apelidos',
	telefonicaUseCorporateMail:
		'* Se es traballador de Telefónica en activo utiliza preferiblemente o teu correo electrónico corporativo.',
	thanks: 'Grazas!',
	typeTheAmount: 'Teclea o importe',
	unavailableLanguageMessage:
		'Non dispoñemos do contido desta campaña en galego. Traballamos constantemente para proporcionar máis contido no teu idioma. Agradecemos a túa comprensión.',
	updatesAndLinks: 'Actualizacións e vínculos',
	validationEqualFields: 'Os campos {{label}} e {{fieldName}} non son iguais',
	validationIsRequired: 'O campo {{label}} é obrigatorio',
	validationValidEmail: 'O campo {{label}} non é un correo electrónico válido',
	viewCampaignInfo: 'Ver información da campaña',
	viewInfo: 'Ver información',
	wantCertificate: 'Quero un certificado de doazón',
	wantWorldcooNewsletter: 'Quero recibir información de Worldcoo',
	whatIsNewAmount: 'Cal é o novo importe que queres doar ({{currency}})?:',
	whatYouWantToDo: 'Que queres facer?',
	whoWillBenefit: 'Quen se beneficiará?',
	youCanAlsoDonateOneTime: 'Tamén podes doar puntualmente a través de calquera deles.',
	yourDonationWillBeCharged: 'A túa doazón cargarase o día 15 de cada mes.',
	yourRequestIsProcessing: 'A túa solicitude estase a procesar. Espera uns segundos, por favor.',
	youSureCancelRecurrentDonation: 'Confirmas que queres cancelar a túa doazón mensual?',
	ngoTermsTitle: 'Información básica sobre Protección de Datos',
	ngoLegitimation: 'La base legal para el tratamiento de sus datos es la obtención de su consentimiento.',
	ngoRecipients: 'No se cederán datos a terceros salvo que exista obligación legal para ello.',
	ngoAdditionalInfoEmail:
		'You can consult the additional and detailed information on Data Protection on the website of each NGO.',
	ngoAdditionalInfoUrl:
		'Na nosa páxina web pódese atopar información adicional e detallada sobre protección de datos: ',
	amountMustBeGreaterThanZero: 'A cantidade debe ser superior a 0',
	amountMustBeLowerThan3000: 'A cantidade debe ser inferior a 3000',
	metafieldsNoTicket: 'Fila 0. Doazón sen entrada',
	metafieldsTickets:
		'Cantas invitacións precisas para o concerto? Ten en conta que por cada 10€ doados recibes unha invitación.',
};
